import { Plant } from "models"
import * as filterEnum from "enums/filterEnum"
import * as util from "lib/util"

export const Dropdown = () =>
	filterEnum.Dropdown<"duns", Plant>({
		getter: ({ api }) => api().Plants({ typeName: util.SupplierPlant }),
		field: "duns",
		label: "DUN",
	})
